import React from 'react'
import Svg from './Svg'
export const SvgBallotBoxCheck = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M21 0c1.646 0 3 1.354 3 3v18c0 1.646-1.354 3-3 3H3c-1.646 0-3-1.354-3-3V3c0-1.646 1.354-3 3-3zm-.588 4.741L9.401 15.755 3.546 9.897l-1.825 1.826 7.68 7.677L22.237 6.566z" />
  </Svg>
))
SvgBallotBoxCheck.isIcon = true
export default SvgBallotBoxCheck
